/**
 * Category API
 *
 * API client methods for category-related endpoints
 */

export { searchCategories } from './searchCategories';
export type { SearchCategoriesParams } from './searchCategories';

export { fetchPopularCategories } from './fetchPopularCategories';
export type { FetchPopularCategoriesParams } from './fetchPopularCategories';

export { fetchPopularSubcategories } from './fetchPopularSubcategories';
export type { FetchPopularSubcategoriesParams } from './fetchPopularSubcategories';
